import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { UserComponent } from './user.component';
import { CompanySelectionComponent } from './components/company-selection/company-selection.component';
import { RedirectGuardService } from 'src/app/shared/libs/auth/redirect-guard.service';
import { AuthGuardService } from 'src/app/shared/libs/auth/auth-guard.service';

const routes: Routes = [
	{
		path: '',
		component: UserComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: 'login',
				component: LoginComponent,
				data: { title: 'Login | BasicStudios' }
			},
			{
				path: 'company-selection',
				component: CompanySelectionComponent,
				data: { title: 'Company Selection | BasicStudios' },
				canActivate: [AuthGuardService]
			  }
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class UserRouting {}
